import '@styles/pages/about.scss';

import { newsletter } from '@organisms/newsletter';

const input = document.getElementById('newsletter_email_about');

newsletter('#form_newsletter_about', input);
